module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm1_m_en.ff2eda13205d7ee08fb33fa4b6952e2a.png";